import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetArticle = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null,category=null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['title'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }

    if (category) {
        params['category_id'] = category;
    }

    params['paginate'] = is_paginate;

    const response = await GET(apiUrl.article, params);
    return response;
}

export const GetArticleById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.article + '/' + id,params);
    return response;
}

export const CreateArticle = async (data) => {
    const response = await POST(apiUrl.article, data);
    return response;
}

export const UpdateArticle = async (id, data) => {
    const response = await PUT(apiUrl.article, id, data);
    return response;
}

export const DeleteArticle = async (id) => {
    const response = await DELETE(apiUrl.article, id);
    return response;
}
